// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"31127400","455":"6c23b4a3","977":"f04bf757"}[chunkId] + ".chunk.js";
};